module.exports = __webpack_public_path__ + "img/cup-0.72c23a72.png";